export const VERSION = '11.0.0-preview.6.26359.118';
//# sourceMappingURL=pkg-version.js.map